import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  WaterMarkStyled,
  StyledImg,
  StyledLink,
} from './styles/WaterMarkStyled';

const WaterMark = ({ url, srcWaterMark, size, clickable }) => (
  <WaterMarkStyled size={size} clickable={clickable}>
    <StyledLink href={url}>
      <StyledImg src={srcWaterMark} alt="watermark" />
    </StyledLink>
  </WaterMarkStyled>
);

WaterMark.propTypes = {
  url: PropTypes.string,
  srcWaterMark: PropTypes.string,
  size: PropTypes.string,
  clickable: PropTypes.bool,
};

WaterMark.defaultProps = {
  url: null,
  srcWaterMark: null,
  size: null,
  clickable: false,
};

export default memo(WaterMark);
